import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Inject, forwardRef, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {MenuService} from './app.menu.service';
import {AppMainComponent} from './app.main.component';

import { AppComponent } from './app.component';
import { IBenutzer } from './_interfaces/benutzer';



@Component({
    /* tslint:disable:component-selector */
    selector: '[app-menuitem]',
    /* tslint:enable:component-selector */
    template: `
        <ng-container>
            <div *ngIf="root && item.visible !== false">
                <span class="layout-menuitem-text">{{item.label}}</span>
            </div>
            <a [attr.href]="item.url" (click)="itemClick($event, item)" *ngIf="item.delimiter == null && ((!item.routerLink || item.items) && item.visible !== false)" (keydown.enter)="itemClick($event, item)"
               [attr.target]="item.target" [attr.tabindex]="0" [ngClass]="item.class" (mouseenter)="onMouseEnter()" pRipple
               [pTooltip]="item.label" [tooltipDisabled]="active || !(root && app.isSlim() && !app.isMobile())">
                <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
                <span class="layout-menuitem-text">{{item.label}}</span>
                <span class="p-badge p-component p-badge-no-gutter" [ngClass]="item.badgeClass" *ngIf="item.badge && !root">{{item.badge}}</span>
                <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
            </a>
            <a (click)="itemClick($event, item)" *ngIf="item.delimiter == null && ((item.routerLink && !item.items) && item.visible !== false)"
               [routerLink]="item.routerLink" routerLinkActive="active-menuitem-routerlink" [routerLinkActiveOptions]="{exact: !item.preventExact}"
               [attr.target]="item.target" [attr.tabindex]="0" [ngClass]="item.class" (mouseenter)="onMouseEnter()" pRipple
               [pTooltip]="item.label" [tooltipDisabled]="active || !(root && app.isSlim() && !app.isMobile())">
                <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
                <span class="layout-menuitem-text">{{item.label}}</span>
                <span class="p-badge p-component p-badge-no-gutter" [ngClass]="item.badgeClass" *ngIf="item.badge && !root">{{item.badge}}</span>
                <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
            </a>
            <hr *ngIf="item.delimiter == true">
            <ul *ngIf="((item.items && root) || (item.items && active)) && item.visible !== false" [@children]="root ? 'visible' : active ? 'visibleAnimated' : 'hiddenAnimated'">
                <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
                    <!--debug: {{child.userCnd}} {{child.label}} {{benutzer.name}}<br>-->
                    <li *ngIf="(child.userCnd == null || child.userCnd == userCnd_isNOTNull && benutzer != null || child.userCnd == userCnd_isNull && benutzer == null) && (child.superAdminOnly != true || (benutzer.istAdmin == true && benutzer.dienstleister != null && ''+benutzer.dienstleister.zuordnung == '')) && (child.adminOnly != true || benutzer.istAdmin == true) && (child.dispoOnly != true || benutzer.disponieren == true)" 
                    app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child.badgeClass"></li>
                </ng-template>
            </ul>
        </ng-container>
    `,
    host: {
        '[class.layout-root-menuitem]': 'root || active',
        '[class.active-menuitem]': '(active)'
    },
    animations: [
        trigger('children', [
            state('void', style({
                height: '0px',
                padding: '0px'
            })),
            state('hiddenAnimated', style({
                height: '0px',
                padding: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*'
            })),
            state('hidden', style({
                height: '0px',
                padding: '0px'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('void => visibleAnimated, visibleAnimated => void',
                animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppMenuitemComponent implements OnInit, OnDestroy {

    @Input() item: any;

    @Input() index: number;

    @Input() root: boolean;

    @Input() parentKey: string;

    @Input() benutzer: IBenutzer;
    
    active = false;

    menuSourceSubscription: Subscription;

    menuResetSubscription: Subscription;

    key: string;

    // da es mit dem Standard aus der primeNG Vorlage zu Verschiebungen beim 2. Öffnen kommt -> alles in ein Array / UL packen!
    userCnd_isNull: string = "N";
    userCnd_isNOTNull: string = "NN";

    constructor(@Inject(forwardRef(() => AppComponent)) public appComp: AppComponent,
        public app: AppMainComponent, public router: Router, private cd: ChangeDetectorRef, private menuService: MenuService) {
        this.menuSourceSubscription = this.menuService.menuSource$.subscribe(key => {
            // deactivate current active menu
            if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
                this.active = false;
            }
        });

        this.menuResetSubscription = this.menuService.resetSource$.subscribe(() => {
            this.active = false;
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(params => {
                if (this.app.isHorizontal() || this.app.isSlim()) {
                    this.active = false;
                } else {
                    if (this.item.routerLink) {
                        this.updateActiveStateFromRoute();
                    } else {
                        this.active = false;
                    }
                }
            });
    }

    ngOnInit() {
        if (!(this.app.isHorizontal() || this.app.isSlim()) && this.item.routerLink) {
            this.updateActiveStateFromRoute();
        }

        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
    }

    updateActiveStateFromRoute() {
        this.active = this.router.isActive(this.item.routerLink[0], !this.item.items && !this.item.preventExact);
    }

    itemClick(event: Event, item) {
        console.log("AppMenuitemComponent.itemClick() event:", event);
        if (item.routeTo != null) {
            console.log("AppMenuitemComponent.itemClick() item.routeTo:", item.routeTo);
            event.preventDefault();
            event.stopPropagation();

            if (item.routeTo == "logout") {
                console.log("AppMenuitemComponent.itemClick() Logout ...");
                this.appComp.logout(); 
                
                //this.app.rightMenuActive = false; // Menü rechts wieder schliessen IRRELEVANT, weil app.logout() sowieso ein reload macht!
            }

            else if (item.routeTo == "route") {
                console.log("AppMenuitemComponent.itemClick() Routenplanung ...");
                this.appComp.startRoutenplanung(); 
                
                this.app.rightMenuActive = false; // Menü rechts wieder schliessen
            }

            else if (item.routeTo == "map") {
                console.log("AppMenuitemComponent.itemClick() Map ...");
                let urlParamsObj:any = {};
                if(this.appComp.mapComponent != null) {
                    urlParamsObj = this.appComp.mapComponent.getCurrentViewParms(); // aktuelle Werte beim Wechsel zw. Map und List mitgeben
                }
                // Map/Liste über Umweg laden, sonst kommt es bei Wechsel zw. dee beiden zu Fehler Leaflet map already initialised
                this.router.navigateByUrl('/dummy', {skipLocationChange: true}).then(() => {
                   setTimeout(() => {
                        this.router.navigate(['/map'], { 
                            //queryParamsHandling: "merge",
                            queryParams: urlParamsObj // aktuelle Werte beim Wechsel zw. Map und List mitgeben
                        });
                    }, 10);		
                });

                this.app.rightMenuActive = false; // Menü rechts wieder schliessen
            }

            else if (item.routeTo == "list") {
                console.log("AppMenuitemComponent.itemClick() Liste ...");
                let urlParamsObj:any = {};
                if(this.appComp.mapComponent != null) {
                    urlParamsObj = this.appComp.mapComponent.getCurrentViewParms(); // aktuelle Werte beim Wechsel zw. Map und List mitgeben
                }
                // Map/Liste über Umweg laden, sonst kommt es bei Wechsel zw. dee beiden zu Fehler Leaflet map already initialised
                this.router.navigateByUrl('/dummy', {skipLocationChange: true}).then(() => {
                   setTimeout(() => {
                        this.router.navigate(['/list'], { 
                            //queryParamsHandling: "merge",
                            queryParams: urlParamsObj // aktuelle Werte beim Wechsel zw. Map und List mitgeben
                        });
                    }, 10);		
                });

                this.app.rightMenuActive = false; // Menü rechts wieder schliessen
            }

            else if (item.routeTo == "dispo") {
                console.log("AppMenuitemComponent.itemClick() Disposition ...");
                this.appComp.dispositionStart(); 
                
                this.app.rightMenuActive = false; // Menü rechts wieder schliessen
            }

            return;
        }

        // avoid processing disabled items
        if (this.item.disabled) {
            event.preventDefault();
            return;
        }

        // navigate with hover in horizontal mode
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // notify other items
        this.menuService.onMenuStateChange(this.key);

        // execute command
        if (this.item.command) {
            this.item.command({originalEvent: event, item: this.item});
        }

        // toggle active state
        if (this.item.items) {
            this.active = !this.active;
        } else {
            // activate item
            this.active = true;

            // reset horizontal and slim menu
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.menuService.reset();
                this.app.menuHoverActive = false;
            }

            if (!this.app.isStatic()) {
                this.app.menuActive = false;
            }

            this.app.mobileMenuActive = false;
        }

        this.removeActiveInk(event);
    }

    onMouseEnter() {
        // activate item on hover
        if (this.root  && (this.app.isHorizontal() || this.app.isSlim()) && this.app.isDesktop()) {
            if (this.app.menuHoverActive) {
                this.menuService.onMenuStateChange(this.key);
                this.active = true;
            }
        }
    }

    removeActiveInk(event: Event) {
        const currentTarget = (event.currentTarget as HTMLElement);
        setTimeout(() => {
            if (currentTarget) {
                const activeInk = currentTarget.querySelector('.p-ink-active');
                if (activeInk) {
                    if (activeInk.classList) {
                        activeInk.classList.remove('p-ink-active');
                    }
                    else {
                        activeInk.className = activeInk.className.replace(new RegExp('(^|\\b)' + 'p-ink-active'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }
                }
            }
        }, 401);
    }

    ngOnDestroy() {
        if (this.menuSourceSubscription) {
            this.menuSourceSubscription.unsubscribe();
        }

        if (this.menuResetSubscription) {
            this.menuResetSubscription.unsubscribe();
        }
    }
}
